// @ts-check

import React from 'react';
import { func, object, string } from 'prop-types';
import PhoneInput from 'react-phone-input-2';
import convertPhone from 'libs/convertPhone';
import './phoneField.css';

/**
 * @component PhoneField
 * @param {Object} props
 * @param {string} props.label
 * @param {string} props.name
 * @param {string} props.value
 * @param {EditorValidType} props.valid
 * @param {(name:string, payload:any)=>void} props.onHandle
 * @returns {JSX.Element}
 */
function PhoneField({ label, name, value, valid, onHandle }) {
	/**
	 * @function onChangePhone
	 * @param {string} phone
	 * @param {Object} data
	 * @param {string} data.name - Ex) "Canada"
	 * @param {string} data.dialCode - Ex) "1"
	 * @param {string} data.countryCode - Ex) "ca"
	 * @param {string} data.format - Ex) ". ...-...-.... Ext-........"
	 * @param {Event} event
	 * @param {string} formattedValue - Ex) 1 000-000-0000 ext-0000
	 * @returns {void}
	 */
	const onChange = (phone, data, event, formattedValue) => {
		const payload = convertPhone(name, data.dialCode, data.countryCode, formattedValue);
		onHandle(name, payload);
	};

	return (
		<section style={{ width: '100%' }}>
			<PhoneInput
				value={value}
				country="ca"
				preferredCountries={['ca', 'us']}
				autoFormat
				prefix=""
				countryCodeEditable={false}
				placeholder=""
				priority={{ ca: 0, us: 1 }}
				isValid={!valid.hasErr}
				defaultErrorMessage="Must be mininum 10 digits without country code"
				masks={{ ca: '...-...-.... Ext-........', at: '...-...-.... Ext-........' }}
				specialLabel={label}
				enableLongNumbers={26}
				// @ts-ignore
				onChange={(phone, data, e, formattedValue) => onChange(phone, data, e, formattedValue)}
				inputStyle={{ height: '2.5rem', backgroundColor: 'var(--cl-paper-bg-main)' }}
			/>
			{valid.hasErr && <p className="input_phone_error_messsage">{valid.msg}</p>}
		</section>
	);
}

PhoneField.propTypes = {
	label: string,
	name: string,
	value: string,
	valid: object,
	onHandle: func,
};

export default PhoneField;
